var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmbeddedProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3375 8.17753C23.5833 8.17753 23.7818 7.97903 23.7818 7.73328V3.14695C23.7818 2.9012 23.5833 2.70203 23.3375 2.70203C23.0917 2.70203 22.8926 2.9012 22.8926 3.14695V7.73328C22.8926 7.97903 23.0917 8.17753 23.3375 8.17753Z",
    fill: "url(#paint0_linear_446_1320)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1064 8.17753C14.3521 8.17753 14.5506 7.97903 14.5506 7.73328V3.14695C14.5506 2.9012 14.3521 2.70203 14.1064 2.70203C13.8606 2.70203 13.6621 2.9012 13.6621 3.14695V7.73328C13.6621 7.97903 13.8606 8.17753 14.1064 8.17753Z",
    fill: "url(#paint1_linear_446_1320)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.663 8.17753C32.9088 8.17753 33.1079 7.97903 33.1079 7.73328V3.14695C33.1079 2.9012 32.9088 2.70203 32.663 2.70203C32.4172 2.70203 32.2188 2.9012 32.2188 3.14695V7.73328C32.2188 7.97903 32.4172 8.17753 32.663 8.17753Z",
    fill: "url(#paint2_linear_446_1320)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8935 8.17753C42.1392 8.17753 42.3377 7.97903 42.3377 7.73328V3.14695C42.3377 2.9012 42.1392 2.70203 41.8935 2.70203C41.6477 2.70203 41.4492 2.9012 41.4492 3.14695V7.73328C41.4492 7.97903 41.6477 8.17753 41.8935 8.17753Z",
    fill: "url(#paint3_linear_446_1320)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73242 33.107C7.97818 33.107 8.17667 32.9078 8.17667 32.662C8.17667 32.4169 7.97818 32.2178 7.73242 32.2178H3.1461C2.90034 32.2178 2.70117 32.4169 2.70117 32.662C2.70117 32.9078 2.90034 33.107 3.1461 33.107H7.73242Z",
    fill: "url(#paint4_linear_446_1320)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73242 41.4492H3.1461C2.90034 41.4492 2.70117 41.6484 2.70117 41.8935C2.70117 42.1386 2.90034 42.3377 3.1461 42.3377H7.73242C7.97818 42.3377 8.17667 42.1386 8.17667 41.8935C8.17667 41.6484 7.97818 41.4492 7.73242 41.4492Z",
    fill: "url(#paint5_linear_446_1320)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73242 23.7824C7.97818 23.7824 8.17667 23.5832 8.17667 23.3381C8.17667 23.0924 7.97818 22.8932 7.73242 22.8932H3.1461C2.90034 22.8932 2.70117 23.0924 2.70117 23.3381C2.70117 23.5832 2.90034 23.7824 3.1461 23.7824H7.73242Z",
    fill: "url(#paint6_linear_446_1320)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1461 14.551H7.73242C7.97818 14.551 8.17667 14.3518 8.17667 14.1067C8.17667 13.8616 7.97818 13.6625 7.73242 13.6625H3.1461C2.90034 13.6625 2.70117 13.8616 2.70117 14.1067C2.70117 14.3518 2.90034 14.551 3.1461 14.551Z",
    fill: "url(#paint7_linear_446_1320)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.663 47.8224C32.4172 47.8224 32.2188 48.0209 32.2188 48.2666V52.853C32.2188 53.0987 32.4172 53.2979 32.663 53.2979C32.9088 53.2979 33.1079 53.0987 33.1079 52.853V48.2666C33.1079 48.0209 32.9088 47.8224 32.663 47.8224Z",
    fill: "url(#paint8_linear_446_1320)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8935 47.8224C41.6477 47.8224 41.4492 48.0209 41.4492 48.2666V52.853C41.4492 53.0987 41.6477 53.2979 41.8935 53.2979C42.1392 53.2979 42.3377 53.0987 42.3377 52.853V48.2666C42.3377 48.0209 42.1386 47.8224 41.8935 47.8224Z",
    fill: "url(#paint9_linear_446_1320)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3375 47.8224C23.0917 47.8224 22.8926 48.0209 22.8926 48.2666V52.853C22.8926 53.0987 23.0917 53.2979 23.3375 53.2979C23.5833 53.2979 23.7818 53.0987 23.7818 52.853V48.2666C23.7818 48.0209 23.5826 47.8224 23.3375 47.8224Z",
    fill: "url(#paint10_linear_446_1320)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1064 47.8224C13.8606 47.8224 13.6621 48.0209 13.6621 48.2666V52.853C13.6621 53.0987 13.8606 53.2979 14.1064 53.2979C14.3521 53.2979 14.5506 53.0987 14.5506 52.853V48.2666C14.5506 48.0209 14.3521 47.8224 14.1064 47.8224Z",
    fill: "url(#paint11_linear_446_1320)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2665 22.8932C48.0208 22.8932 47.8223 23.0924 47.8223 23.3381C47.8223 23.5832 48.0208 23.7824 48.2665 23.7824H52.8528C53.0986 23.7824 53.2978 23.5832 53.2978 23.3381C53.2978 23.0924 53.0986 22.8932 52.8528 22.8932H48.2665Z",
    fill: "url(#paint12_linear_446_1320)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2665 14.551H52.8528C53.0986 14.551 53.2978 14.3518 53.2978 14.1067C53.2978 13.8616 53.0986 13.6625 52.8528 13.6625H48.2665C48.0208 13.6625 47.8223 13.8616 47.8223 14.1067C47.8223 14.3518 48.0208 14.551 48.2665 14.551Z",
    fill: "url(#paint13_linear_446_1320)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56 20.4754V16.8755C56 16.6304 55.8015 16.4312 55.5557 16.4312H45.2353V11.2089C45.2353 10.9638 45.0368 10.7647 44.7911 10.7647H39.5688V0.444252C39.5688 0.199171 39.3703 0 39.1245 0H35.5246C35.2788 0 35.0797 0.199171 35.0797 0.444252V10.7647H30.2442V0.444252C30.2442 0.199171 30.0457 0 29.8 0H26.2C25.9543 0 25.7558 0.199171 25.7558 0.444252V10.7647H20.9203V0.444252C20.9203 0.199171 20.7212 0 20.4754 0H16.8755C16.6297 0 16.4312 0.199171 16.4312 0.444252V10.7647H11.2089C10.9632 10.7647 10.7647 10.9638 10.7647 11.2089V16.4312H0.444252C0.198496 16.4312 0 16.6304 0 16.8755V20.4754C0 20.7212 0.198496 20.9203 0.444252 20.9203H10.7647V25.7558H0.444252C0.198496 25.7558 0 25.955 0 26.2V29.8C0 30.045 0.198496 30.2442 0.444252 30.2442H10.7647V35.0797H0.444252C0.198496 35.0797 0 35.2788 0 35.5246V39.1245C0 39.3696 0.198496 39.5688 0.444252 39.5688H10.7647V44.7911C10.7647 45.0362 10.9632 45.2353 11.2089 45.2353H16.4312V55.5557C16.4312 55.8008 16.6297 56 16.8755 56H20.4761C20.7218 56 20.9203 55.8008 20.9203 55.5557V45.2353H25.7558V55.5557C25.7558 55.8008 25.955 56 26.2007 56H29.8006C30.0464 56 30.2449 55.8008 30.2449 55.5557V45.2353H35.0803V55.5557C35.0803 55.8008 35.2788 56 35.5246 56H39.1252C39.3709 56 39.5694 55.8008 39.5694 55.5557V45.2353H44.7918C45.0375 45.2353 45.2367 45.0362 45.2367 44.7911V39.5688H55.5557C55.8015 39.5688 56 39.3696 56 39.1245V35.5246C56 35.2788 55.8015 35.0797 55.5557 35.0797H45.2353V30.2442H55.5557C55.8015 30.2442 56 30.045 56 29.8V26.2C56 25.955 55.8015 25.7558 55.5557 25.7558H45.2353V20.9203H55.5557C55.8015 20.9203 56 20.7212 56 20.4754ZM33.0353 28C33.0353 30.7769 30.7762 33.0353 28 33.0353C25.2238 33.0353 22.9647 30.7769 22.9647 28C22.9647 25.2231 25.2238 22.9647 28 22.9647C30.7762 22.9647 33.0353 25.2231 33.0353 28Z",
    fill: "url(#paint14_linear_446_1320)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2665 32.2178C48.0208 32.2178 47.8223 32.4169 47.8223 32.662C47.8223 32.9078 48.0208 33.107 48.2665 33.107H52.8528C53.0986 33.107 53.2978 32.9078 53.2978 32.662C53.2978 32.4169 53.0986 32.2178 52.8528 32.2178H48.2665Z",
    fill: "url(#paint15_linear_446_1320)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8528 41.4492H48.2665C48.0208 41.4492 47.8223 41.6484 47.8223 41.8935C47.8223 42.1386 48.0208 42.3377 48.2665 42.3377H52.8528C53.0986 42.3377 53.2978 42.1386 53.2978 41.8935C53.2978 41.6484 53.0986 41.4492 52.8528 41.4492Z",
    fill: "url(#paint16_linear_446_1320)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_446_1320",
    x1: 23.3372,
    y1: 2.70203,
    x2: 23.3372,
    y2: 8.17753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_446_1320",
    x1: 14.1064,
    y1: 2.70203,
    x2: 14.1064,
    y2: 8.17753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_446_1320",
    x1: 32.6633,
    y1: 2.70203,
    x2: 32.6633,
    y2: 8.17753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_446_1320",
    x1: 41.8935,
    y1: 2.70203,
    x2: 41.8935,
    y2: 8.17753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_446_1320",
    x1: 5.43892,
    y1: 32.2178,
    x2: 5.43892,
    y2: 33.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_446_1320",
    x1: 5.43892,
    y1: 41.4492,
    x2: 5.43892,
    y2: 42.3377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_446_1320",
    x1: 5.43892,
    y1: 22.8932,
    x2: 5.43892,
    y2: 23.7824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_446_1320",
    x1: 5.43892,
    y1: 13.6625,
    x2: 5.43892,
    y2: 14.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_446_1320",
    x1: 32.6633,
    y1: 47.8224,
    x2: 32.6633,
    y2: 53.2979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_446_1320",
    x1: 41.8935,
    y1: 47.8224,
    x2: 41.8935,
    y2: 53.2979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_446_1320",
    x1: 23.3372,
    y1: 47.8224,
    x2: 23.3372,
    y2: 53.2979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_446_1320",
    x1: 14.1064,
    y1: 47.8224,
    x2: 14.1064,
    y2: 53.2979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_446_1320",
    x1: 50.56,
    y1: 22.8932,
    x2: 50.56,
    y2: 23.7824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_446_1320",
    x1: 50.56,
    y1: 13.6625,
    x2: 50.56,
    y2: 14.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_446_1320",
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_446_1320",
    x1: 50.56,
    y1: 32.2178,
    x2: 50.56,
    y2: 33.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_446_1320",
    x1: 50.56,
    y1: 41.4492,
    x2: 50.56,
    y2: 42.3377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbeddedProduct);
export default __webpack_public_path__ + "static/media/EmbeddedProduct.577ea8bbe7319f98953b83ffc8f01315.svg";
export { ForwardRef as ReactComponent };